import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  createClient,
  updateClient,
} from "../../../redux/features/clients/clientSlice";

import "./ClientForm.css";

const initialState = {
  first_name: "",
  last_name: "",
};

export default function ClientForm({
  mode = "create",
  initialData = null,
  onSuccess,
  onCancel,
}) {
  const dispatch = useDispatch();

  const { isCreating, isUpdating, error } = useSelector(
    (state) => state.clients,
  );

  const [formData, setFormData] = useState(initialState);

  const [validationErrors, setValidationErrors] = useState({});

  const isEditMode = mode === "edit";

  const isSubmitting = isCreating || isUpdating;

  useEffect(() => {
    if (isEditMode && initialData) {
      setFormData({
        first_name: initialData.first_name || "",
        last_name: initialData.last_name || "",
      });
    }

    if (!isEditMode) {
      setFormData(initialState);
    }
  }, [isEditMode, initialData]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setValidationErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.first_name.trim()) {
      errors.first_name = "Voornaam is verplicht.";
    }

    if (!formData.last_name.trim()) {
      errors.last_name = "Achternaam is verplicht.";
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const buildPayload = () => ({
    first_name: formData.first_name.trim(),
    last_name: formData.last_name.trim(),
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    try {
      if (isEditMode) {
        await dispatch(
          updateClient({
            id: initialData._id,
            data: buildPayload(),
          }),
        ).unwrap();
      } else {
        await dispatch(createClient(buildPayload())).unwrap();
      }

      onSuccess?.();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form className="client-form" onSubmit={handleSubmit}>
      {error && <div className="client-form__error">{error}</div>}

      <div className="client-form__grid">
        <div className="client-form__group">
          <label>Voornaam *</label>

          <input
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            disabled={isSubmitting}
            placeholder="Voornaam"
            className={
              validationErrors.first_name ? "client-form__input--error" : ""
            }
          />

          {validationErrors.first_name && (
            <span>{validationErrors.first_name}</span>
          )}
        </div>

        <div className="client-form__group">
          <label>Achternaam *</label>

          <input
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            disabled={isSubmitting}
            placeholder="Achternaam"
            className={
              validationErrors.last_name ? "client-form__input--error" : ""
            }
          />

          {validationErrors.last_name && (
            <span>{validationErrors.last_name}</span>
          )}
        </div>
      </div>

      <div className="client-form__actions">
        <button
          type="button"
          className="client-form__cancel"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Annuleren
        </button>

        <button
          type="submit"
          className="client-form__submit"
          disabled={isSubmitting}
        >
          {isSubmitting
            ? "Opslaan..."
            : isEditMode
              ? "Wijzigingen opslaan"
              : "Cliënt aanmaken"}
        </button>
      </div>
    </form>
  );
}
